module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d34dbc2d88a3e8dc9d81770eb9145b08.png";